"use client";

import { motion, Variants } from "motion/react";

interface LoadingScreenProps {
  isVisible: boolean;
}

function LoadingScreen({ isVisible }: LoadingScreenProps) {
  const containerVariants: Variants = {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.3,
        ease: "easeIn",
      },
    },
  };

  const dotVariants: Variants = {
    pulse: {
      opacity: [1, 0.3, 1],
      transition: {
        duration: 0.8,
        repeat: Infinity,
        repeatType: "loop",
        ease: "easeInOut",
      },
    },
  };

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate={isVisible ? "visible" : "exit"}
      exit="exit"
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: "var(--color-alias-white)" }}
      role="status"
      aria-live="polite"
      aria-busy={isVisible}
    >
      <motion.div
        animate="pulse"
        transition={{ staggerChildren: 0.2 }}
        className="container"
      >
        <motion.div className="dot" variants={dotVariants} />
        <motion.div className="dot" variants={dotVariants} />
        <motion.div className="dot" variants={dotVariants} />
        <StyleSheet />
      </motion.div>
    </motion.div>
  );
}

/**
 * ==============   Styles   ================
 */
function StyleSheet() {
  return (
    <style>
      {`
      .container {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
      }

      .dot {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background-color: var(--color-alias-tertiary);
          will-change: opacity;
      }
      `}
    </style>
  );
}

export default LoadingScreen;
